import { toolsReducers } from '../reducers'

export const toolsRootReducers = {
  tools: toolsReducers,
}
